import { jsx as _jsx } from "react/jsx-runtime";
import { defineMessages, useIntl } from 'react-intl';
import YearSelect from '../YearSelect';
const messages = defineMessages({
    ReferenceYear: {
        id: 'ReferenceYear',
        defaultMessage: 'ReferenceYear',
    },
    WithoutReferenceYear: {
        id: 'WithoutReferenceYear',
        defaultMessage: 'Without reference year',
    },
});
export const FilterReferenceYear = ({ item, setFilter, activeFilters, label, isAlwaysVisible, enabled, }) => {
    const { formatMessage } = useIntl();
    return {
        filterItem: item,
        enabled: enabled,
        filterSelectLabel: !isAlwaysVisible ? label : undefined,
        element: (_jsx(YearSelect, { id: "yearFilter", value: activeFilters[item], onChange: value => {
                setFilter({ [item]: value });
            }, placeholder: formatMessage(messages.ReferenceYear), withoutOption: formatMessage(messages.WithoutReferenceYear) })),
    };
};
